import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M20 2c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2zm-8 17c2.83 0 5.21-1.97 5.84-4.61.17-.74-.49-1.41-1.23-1.23C13.97 13.79 12 16.17 12 19v-.021l-.005-.2275c-.108-2.6376-1.9273-4.8426-4.3738-5.5314L7.39 13.16c-.74-.17-1.41.49-1.23 1.23C6.79 17.03 9.17 19 12 19zm0-13.74c-.86 0-1.56.7-1.56 1.56l.01.12c-.25-.18-.56-.28-.89-.28-.86 0-1.56.7-1.56 1.56 0 .62.37 1.16.89 1.41-.52.24-.89.78-.89 1.4 0 .86.7 1.56 1.56 1.56.33 0 .63-.1.89-.28l-.01.12c0 .86.7 1.56 1.56 1.56s1.56-.7 1.56-1.56l-.01-.12c.25.17.56.28.89.28.86 0 1.56-.7 1.56-1.56 0-.62-.37-1.16-.89-1.41.52-.24.89-.78.89-1.4 0-.86-.7-1.56-1.56-1.56-.33 0-.63.1-.89.28l.01-.12c0-.86-.7-1.56-1.56-1.56zm0 2.8c.8616 0 1.56.6984 1.56 1.56s-.6984 1.56-1.56 1.56-1.56-.6984-1.56-1.56.6984-1.56 1.56-1.56z"
  }],
  circles: []
};
var YardIcon = function YardIcon(props) {
  return renderIcon(props, iconType);
};
export { YardIcon };